import {default as tokenStorage} from './tokenStorage.js';
import appConfig from '../config';

const Auth= {
	
	session:null,
	
	getSession(){
		return this.session;
	},
	
	accessTokenExists(){
		let token = this.getAccessToken();
		if(token && token!='')
			return true;
		return false;
	},
	
	getAccessToken(){
        let token = tokenStorage.getAccessToken()
        //如果是测试环境，在客户端生成令牌
        if(process.env.NODE_ENV=='development'){
			if(token){
				if(!this.verifyToken(token)){
					token = '';
				}
			}
            if(!token || token==''){
                token = this.createDevToken();
                this.setAccessToken(token);
            }
        }
        
		return token;
	},
	
	setAccessToken(token){
		tokenStorage.setAccessToken(token);
	},
	
	logout(){
		tokenStorage.removeAccessToken();
		this.session=null;
	},
	
	login(aSession){
		this.setAccessToken(aSession.token);
		this.setSession(aSession);
	},
	
	setSession(aSession){
		this.session=aSession;
    },
    
    createDevToken(){
        const jwt = require('jsonwebtoken');
        let token = jwt.sign(appConfig.devTokenPayload, appConfig.devTokenSignSecret, {expiresIn: 12 * 60 * 60});
        console.log("creating dev token:");
        console.log(token);
        return token;
    },

	verifyToken(token){
		const jwt = require('jsonwebtoken');
		try {
			return jwt.verify(token, appConfig.devTokenSignSecret); // 如果过期将返回false
		} catch (e) {
			console.error('jwt verify error --->', e);
			return false;
		}
	}
	
};

export default Auth;
